import { useState } from 'react';
import api from '../../api/axios';
import styles from './GraficoParceiro.module.css';

export default function AbrirClienteParceiro({ vendaId }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const abrir = async () => {
        setLoading(true);
        setError(false);
        try {
            const { data } = await api.get(`/parceiros/vendas/${encodeURIComponent(vendaId)}/cliente`);
            if (!data.status || !/^\/formularios?\/[^/]+$/.test(data.url)) throw new Error('Link invalido');
            window.location.assign(data.url);
        } catch {
            setError(true);
        } finally {
            setLoading(false);
        }
    };
    return <>
        <button type="button" className={styles.openClient} disabled={loading} onClick={abrir}>
            {loading ? 'Abrindo...' : 'Abrir cliente'}
        </button>
        {error && <span role="alert">Não foi possível abrir o cliente. Tente novamente.</span>}
    </>;
}
